module.exports = ".statusdue {\n  margin-top: 30px;\n  background-color: #fffcfc;\n  padding: 10px;\n  margin-left: 0px !important;\n  margin-right: 0px !important; }\n\n.searchText {\n  background-color: #fffcfc;\n  padding: 10px;\n  margin-left: 0px !important;\n  margin-right: 0px !important; }\n\n.marginTop {\n  margin-top: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/invoice-report/invoice-report.component.scss
// module id = ./client/app/invoice-report/invoice-report.component.scss
// module chunks = main